
window.onload = function() {
  
  //    $('.product-medias__main .cstm_product_slider').slick({
  //   infinite: true,
  //   speed: 300,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows:true,
  //   prevArrow: '<div class="swiper-button-prev swiper_prev_btn"><svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="Zoom-In_OnHover" transform="translate(-1238 -470)"><g id="Group-4" transform="translate(158 470)"><g id="Group-3" transform="matrix(-1 0 0 1 1130 0)"><g id="Group-9" fill="#FFF"><circle id="Oval-2" cx="25" cy="25" r="25"></circle></g><g transform="rotate(90 4 24)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M0.5,0.5 L5.02268051,5.02268051" id="Line"></path><path d="M4.5,0.5 L9.02268051,5.02268051" id="Line-Copy" transform="matrix(-1 0 0 1 14 0)"></path></g></g></g></g></g></svg></div> ',
  //   nextArrow:'<div class="swiper-button-next swiper_next_btn"><svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="Zoom-In_OnHover" transform="translate(-1238 -470)"><g id="Group-4" transform="translate(158 470)"><g id="Group-3" transform="matrix(-1 0 0 1 1130 0)"><g id="Group-9" fill="#FFF"><circle id="Oval-2" cx="25" cy="25" r="25"></circle></g><g transform="rotate(90 4 24)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M0.5,0.5 L5.02268051,5.02268051" id="Line"></path><path d="M4.5,0.5 L9.02268051,5.02268051" id="Line-Copy" transform="matrix(-1 0 0 1 14 0)"></path></g></g></g></g></g></svg></div>'
      
  // });
  
};


$(document).ready(function(){


  $('.slider_collection').slick({
    infinite: true,
    speed: 300,
    slidesToShow: 7,
    slidesToScroll: 3,
    dots:true,
    arrows:false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          adaptiveHeight: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.feature_slide').slick({
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots:false,
    prevArrow:'<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="24" height="24"><path d="M13.775,18.707,8.482,13.414a2,2,0,0,1,0-2.828l5.293-5.293,1.414,1.414L9.9,12l5.293,5.293Z"/></svg></button>',
    nextArrow:'<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="24" height="24"><path d="M10.811,18.707,9.4,17.293,14.689,12,9.4,6.707l1.415-1.414L16.1,10.586a2,2,0,0,1,0,2.828Z"/></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $(document).on('click',".zoom-icon", function(){
    $(this).closest('.swiper-slide').find('.gallery img').click();
  });
  $(document).on('click',".product-medias__media.gallery img", function(){
     $('.product-modal').show();
     var imageId=$(this).parent().attr('data-media-id');
     var dataproducthandle=$(this).attr("data-product");
     var dataId = $(this).parent().attr('data-media-id');
     var dataThumbIndex = $('a.product-medias__thumbnail[data-media-id="'+dataId+'"]').attr('data-index');
    // console.log(dataId);
    
      $.getJSON(window.Shopify.routes.root + 'products/'+dataproducthandle+'.js', function(product) { 
     
      var mediaLenght = product['media'].length;
      var productThumbimages=product['media']; 
      var slider='<div class="swiper-container productImages"><div class="swiper-wrappers"></div><div>';
      var sliderButton='<div class="swiper-button-prev"></div><div class="swiper-button-next"></div><div class="swiper-pagination"></div>'; 
       
      if($('.productImages').length > 0){}else{
       $('.product-modal-inner').append(slider);
       $('.swiper-container.productImages').append(sliderButton);
         
       $.each(productThumbimages, function(key,value) {
            var productItemId=value['id'];
            var productItemImage=value['src']; 
            var productMainImg='<div class="swiper-slide" id="'+productItemId+'"><img class="Main_image"  src="'+productItemImage+'"/></div>';
            $('.productImages .swiper-wrappers').append(productMainImg);
       
       }); 
            $('.productImages .swiper-wrappers').slick({
            slidesToShow: 1,
            arrows:true,
            infinite: true,
            adaptiveHeight: true,
            centerMode:false,
            dots: true,
            prevArrow:'<button type="button" class="slick-prev pull-left"><svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="Zoom-In_OnHover" transform="translate(-1238 -470)"><g id="Group-4" transform="translate(158 470)"><g id="Group-3" transform="matrix(-1 0 0 1 1130 0)"><g id="Group-9" fill="#FFF"><circle id="Oval-2" cx="25" cy="25" r="25"></circle></g><g transform="rotate(90 4 24)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M0.5,0.5 L5.02268051,5.02268051" id="Line"></path><path d="M4.5,0.5 L9.02268051,5.02268051" id="Line-Copy" transform="matrix(-1 0 0 1 14 0)"></path></g></g></g></g></g></svg></button>',
            nextArrow:'<button type="button" class="slick-next pull-right"><svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="Zoom-In_OnHover" transform="translate(-1238 -470)"><g id="Group-4" transform="translate(158 470)"><g id="Group-3" transform="matrix(-1 0 0 1 1130 0)"><g id="Group-9" fill="#FFF"><circle id="Oval-2" cx="25" cy="25" r="25"></circle></g><g transform="rotate(90 4 24)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M0.5,0.5 L5.02268051,5.02268051" id="Line"></path><path d="M4.5,0.5 L9.02268051,5.02268051" id="Line-Copy" transform="matrix(-1 0 0 1 14 0)"></path></g></g></g></g></g></svg></button>'
          });
        } 
        $('.productImages .swiper-wrappers').slick('slickGoTo', dataThumbIndex);
     }); 
      
  });

  
  $(document).on('click',".product-modal-close", function(){
    $('.product-modal').hide();
  }); 

  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  
  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }
  
  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });
  
  });

if ($(".new__testimonal").length) {
    var swiper = new Swiper(".new__testimonal", {
        slidesPerView: 1,
        infinite: true,
        loop: true,
        speed: 5000,
        delay: 11000, 
        autoplay: {
            delay: 11000,
        }, 
        centeredSlides: true,
        grabCursor: true, 
        keyboard: {
            enabled: true,
        }, 
        observer: true,
        observeParents: true,
        navigation: {
            nextEl: '.swiper-button-next.new__testimonal_next',
            prevEl: '.swiper-button-prev.new__testimonal_prev',
        }
    });
}


 // $('.newTesti').slick({
 //    infinite: true,
 //    speed: 300,
 //    slidesToShow: 1,
 //    slidesToScroll: 1,
 //    dots:false,
 //    adaptiveHeight: true,
 //    prevArrow:'<button type="button" class="slick-prev pull-left" ><svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" style="border-radius:50%; background-color:white;"  data-name="Layer 1" viewBox="0 0 24 24" width="40" height="40"><path d="M13.775,18.707,8.482,13.414a2,2,0,0,1,0-2.828l5.293-5.293,1.414,1.414L9.9,12l5.293,5.293Z"/></svg></button>',
 //    nextArrow:'<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" style="border-radius:50%; background-color:white;" data-name="Layer 1" viewBox="0 0 24 24" width="40" height="40"><path d="M10.811,18.707,9.4,17.293,14.689,12,9.4,6.707l1.415-1.414L16.1,10.586a2,2,0,0,1,0,2.828Z"/></svg></button>',
 //   }); 

  // var swiper = new Swiper(".newTesti", {
  //       loop: true,
        
  //       slidesPerView: 1,
  //       paginationClickable: true,
  //       spaceBetween: 20,
  //     // slidesPerView: 1,
  //     // infinite: true,
  //     // loop: true,
  //     // speed:5000,
  //     // delay:11000, 
  //     // autoplay:true, 
  //     // centeredSlides:true,
  //     // grabCursor: true, 
  //     // keyboardControl: true, 
  //     // observer: true,
  //     // observeParents: true,
  //     navigation: {
  //       nextEl: '.swiper-button-next.new__testimonal_next',
  //       prevEl: '.swiper-button-prev.new__testimonal_prev',
  //     }
       
  //   });

  
/*--------- Faq Accordion Start ----------------*/
  function initializeTabs() {
  var $titleTab = $('.title_tab');

  // 2 second delay ke baad pehla tab active hoga
  setTimeout(function() {
    $('.title_tab:first').addClass('active');
  }, 2000);

  // Tab click functionality
  $titleTab.on('click', function(e) {
    e.preventDefault();

    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $(this).next().stop().slideUp(500);
      $(this).next().find('p').removeClass('show');
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(500);
      $(this).parent().siblings().children('.title_tab').removeClass('active');
      $(this).parent().siblings().children('.inner_content').slideUp(500);
      $(this).parent().siblings().children('.inner_content').find('p').removeClass('show');
      $(this).next().find('p').addClass('show');
    }
  });
}

// Function ko call karo jab DOM ready ho
$(document).ready(function() {
  initializeTabs();
});


  // setTimeout(function() {
  //   document.querySelector('.accordion__content#ProductAccordion-collapsible_tab_PCfhrm-template--product').style.display = 'block';
  // }, 2000);
//   $('.title_tab:first').addClass('active');
// var $titleTab = $('.title_tab');
	
// 	$titleTab.on('click', function(e) {
// 	e.preventDefault();
// 		if ( $(this).hasClass('active') ) {
// 			$(this).removeClass('active');
// 			$(this).next().stop().slideUp(500);
// 			$(this).next().find('p').removeClass('show');
// 		} else {
// 			$(this).addClass('active');
// 			$(this).next().stop().slideDown(500);
// 			$(this).parent().siblings().children('.title_tab').removeClass('active');
// 			$(this).parent().siblings().children('.inner_content').slideUp(500);
// 			$(this).parent().siblings().children('.inner_content').find('p').removeClass('show');
// 			$(this).next().find('p').addClass('show');
// 		}
// 	});

/*--------- Faq Accordion End ----------------*/
  if($('.product-personalizer').length){
    
    }else{
        $('#AddToCart').removeClass('btn-error');
    }



});







// window.onload = function() {
  
//   //    $('.product-medias__main .cstm_product_slider').slick({
//   //   infinite: true,
//   //   speed: 300,
//   //   slidesToShow: 1,
//   //   slidesToScroll: 1,
//   //   arrows:true,
//   //   prevArrow: '<div class="swiper-button-prev swiper_prev_btn"><svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="Zoom-In_OnHover" transform="translate(-1238 -470)"><g id="Group-4" transform="translate(158 470)"><g id="Group-3" transform="matrix(-1 0 0 1 1130 0)"><g id="Group-9" fill="#FFF"><circle id="Oval-2" cx="25" cy="25" r="25"></circle></g><g transform="rotate(90 4 24)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M0.5,0.5 L5.02268051,5.02268051" id="Line"></path><path d="M4.5,0.5 L9.02268051,5.02268051" id="Line-Copy" transform="matrix(-1 0 0 1 14 0)"></path></g></g></g></g></g></svg></div> ',
//   //   nextArrow:'<div class="swiper-button-next swiper_next_btn"><svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="Zoom-In_OnHover" transform="translate(-1238 -470)"><g id="Group-4" transform="translate(158 470)"><g id="Group-3" transform="matrix(-1 0 0 1 1130 0)"><g id="Group-9" fill="#FFF"><circle id="Oval-2" cx="25" cy="25" r="25"></circle></g><g transform="rotate(90 4 24)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M0.5,0.5 L5.02268051,5.02268051" id="Line"></path><path d="M4.5,0.5 L9.02268051,5.02268051" id="Line-Copy" transform="matrix(-1 0 0 1 14 0)"></path></g></g></g></g></g></svg></div>'
      
//   // });
  
// };


// $(document).ready(function(){  

//   $('.slider_collection').slick({
//     infinite: true,
//     speed: 300,
//     slidesToShow: 7,
//     slidesToScroll: 3,
//     dots:true,
//     arrows:false,
//     responsive: [
//       {
//         breakpoint: 1025,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 2,
//           adaptiveHeight: true
//         }
//       },
//       {
//         breakpoint: 600,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 2
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//     ]
//   });

//   $('.feature_slide').slick({
//     infinite: true,
//     speed: 300,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     dots:false,
//     prevArrow:'<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="24" height="24"><path d="M13.775,18.707,8.482,13.414a2,2,0,0,1,0-2.828l5.293-5.293,1.414,1.414L9.9,12l5.293,5.293Z"/></svg></button>',
//     nextArrow:'<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="24" height="24"><path d="M10.811,18.707,9.4,17.293,14.689,12,9.4,6.707l1.415-1.414L16.1,10.586a2,2,0,0,1,0,2.828Z"/></svg></button>',
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 3,
//           infinite: true
//         }
//       },
//       {
//         breakpoint: 600,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 2
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//     ]
//   });

//   $(document).on('click',".zoom-icon", function(){
//     $(this).closest('.swiper-slide').find('.gallery img').click();
//   });
//   $(document).on('click',".product-medias__media.gallery img", function(){
//      $('.product-modal').show();
//      var imageId=$(this).parent().attr('data-media-id');
//      var dataproducthandle=$(this).attr("data-product");
//      var dataId = $(this).parent().attr('data-media-id');
//      var dataThumbIndex = $('a.product-medias__thumbnail[data-media-id="'+dataId+'"]').attr('data-index');
//     // console.log(dataId);
    
//       $.getJSON(window.Shopify.routes.root + 'products/'+dataproducthandle+'.js', function(product) { 
     
//       var mediaLenght = product['media'].length;
//       var productThumbimages=product['media']; 
//       var slider='<div class="swiper-container productImages"><div class="swiper-wrappers"></div><div>';
//       var sliderButton='<div class="swiper-button-prev"></div><div class="swiper-button-next"></div><div class="swiper-pagination"></div>'; 
       
//       if($('.productImages').length > 0){}else{
//        $('.product-modal-inner').append(slider);
//        // $('.swiper-container.productImages').append(sliderButton);
         
//        $.each(productThumbimages, function(key,value) {
//             var productItemId=value['id'];
//             var productItemImage=value['src']; 
//             var productMainImg='<div class="swiper-slide" id="'+productItemId+'"><img class="Main_image"  src="'+productItemImage+'"/></div>';
//             $('.productImages .swiper-wrappers').append(productMainImg);
       
//        }); 
//             $('.productImages .swiper-wrappers').slick({
//             slidesToShow: 1,
//             arrows:true,
//             infinite: true,
//             adaptiveHeight: true,
//             centerMode:false,
//             dots: true,
//             prevArrow:'<button type="button" class="slick-prev pull-left"><svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="Zoom-In_OnHover" transform="translate(-1238 -470)"><g id="Group-4" transform="translate(158 470)"><g id="Group-3" transform="matrix(-1 0 0 1 1130 0)"><g id="Group-9" fill="#FFF"><circle id="Oval-2" cx="25" cy="25" r="25"></circle></g><g transform="rotate(90 4 24)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M0.5,0.5 L5.02268051,5.02268051" id="Line"></path><path d="M4.5,0.5 L9.02268051,5.02268051" id="Line-Copy" transform="matrix(-1 0 0 1 14 0)"></path></g></g></g></g></g></svg></button>',
//             nextArrow:'<button type="button" class="slick-next pull-right"><svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="Zoom-In_OnHover" transform="translate(-1238 -470)"><g id="Group-4" transform="translate(158 470)"><g id="Group-3" transform="matrix(-1 0 0 1 1130 0)"><g id="Group-9" fill="#FFF"><circle id="Oval-2" cx="25" cy="25" r="25"></circle></g><g transform="rotate(90 4 24)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M0.5,0.5 L5.02268051,5.02268051" id="Line"></path><path d="M4.5,0.5 L9.02268051,5.02268051" id="Line-Copy" transform="matrix(-1 0 0 1 14 0)"></path></g></g></g></g></g></svg></button>'
//           });
//         } 
//         $('.productImages .swiper-wrappers').slick('slickGoTo', dataThumbIndex);
//      }); 
      
//   });

  
//   $(document).on('click',".product-modal-close", function(){
//     $('.product-modal').hide();
//   }); 

//   document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
//   summary.setAttribute('role', 'button');
//   summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  
//   if (summary.nextElementSibling.getAttribute('id')) {
//     summary.setAttribute('aria-controls', summary.nextElementSibling.id);
//   }
  
//   summary.addEventListener('click', (event) => {
//     event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
//   });
  
//   });


   

// if ($(".new__testimonal").length) {
//     var swiper = new Swiper(".new__testimonal", {
//         slidesPerView: 1,
//         infinite: true,
//         loop: true,
//         speed: 5000,
//         delay: 11000, 
//         autoplay: {
//             delay: 11000,
//         }, 
//         centeredSlides: true,
//         grabCursor: true, 
//         keyboard: {
//             enabled: true,
//         }, 
//         observer: true,
//         observeParents: true,
//         navigation: {
//             nextEl: '.swiper-button-next.new__testimonal_next',
//             prevEl: '.swiper-button-prev.new__testimonal_prev',
//         }
//     });
// }


//  $('.newTesti').slick({
//     infinite: true,
//     speed: 300,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     dots:false,
//     adaptiveHeight: true,
//     prevArrow:'<button type="button" class="slick-prev pull-left" ><svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" style="border-radius:50%; background-color:white;"  data-name="Layer 1" viewBox="0 0 24 24" width="40" height="40"><path d="M13.775,18.707,8.482,13.414a2,2,0,0,1,0-2.828l5.293-5.293,1.414,1.414L9.9,12l5.293,5.293Z"/></svg></button>',
//     nextArrow:'<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" style="border-radius:50%; background-color:white;" data-name="Layer 1" viewBox="0 0 24 24" width="40" height="40"><path d="M10.811,18.707,9.4,17.293,14.689,12,9.4,6.707l1.415-1.414L16.1,10.586a2,2,0,0,1,0,2.828Z"/></svg></button>',
//    }); 

//   // var swiper = new Swiper(".newTesti", {
//   //       loop: true,
        
//   //       slidesPerView: 1,
//   //       paginationClickable: true,
//   //       spaceBetween: 20,
//   //     // slidesPerView: 1,
//   //     // infinite: true,
//   //     // loop: true,
//   //     // speed:5000,
//   //     // delay:11000, 
//   //     // autoplay:true, 
//   //     // centeredSlides:true,
//   //     // grabCursor: true, 
//   //     // keyboardControl: true, 
//   //     // observer: true,
//   //     // observeParents: true,
//   //     navigation: {
//   //       nextEl: '.swiper-button-next.new__testimonal_next',
//   //       prevEl: '.swiper-button-prev.new__testimonal_prev',
//   //     }
       
//   //   });

  
// /*--------- Faq Accordion Start ----------------*/
//   $('.title_tab:first').addClass('active');
// var $titleTab = $('.title_tab');
	
// 	$titleTab.on('click', function(e) {
// 	e.preventDefault();
// 		if ( $(this).hasClass('active') ) {
// 			$(this).removeClass('active');
// 			$(this).next().stop().slideUp(500);
// 			$(this).next().find('p').removeClass('show');
// 		} else {
// 			$(this).addClass('active');
// 			$(this).next().stop().slideDown(500);
// 			$(this).parent().siblings().children('.title_tab').removeClass('active');
// 			$(this).parent().siblings().children('.inner_content').slideUp(500);
// 			$(this).parent().siblings().children('.inner_content').find('p').removeClass('show');
// 			$(this).next().find('p').addClass('show');
// 		}
// 	});

// /*--------- Faq Accordion End ----------------*/
//   if($('.product-personalizer').length){
    
//     }else{
//         $('#AddToCart').removeClass('btn-error');
//     }



// });
document.addEventListener('DOMContentLoaded', function() {
  // Give Vue time to mount
  setTimeout(function() {
    var vue = document.querySelector('.product-single-wrapper')?.__vue__;
    if (!vue) return;
    document.querySelectorAll('.product-medias__media[data-media-id]').forEach(function(el) {
      var mediaId = parseInt(el.dataset.mediaId, 10);
      var wrapper = vue.mediaWrapperById?.get(mediaId);
      if (wrapper && !wrapper.el) {
        wrapper.el = el;
        // Attach click listener the same way onMediaLoaded does
        el.addEventListener('click', vue.onMediaActivate.bind(vue));
      }
    });
  }, 2000);
});

document.addEventListener('click', function (event) {
  var choice = event.target.closest('.posy-cover-choice');
  if (!choice) return;
  var card = choice.closest('.grid-view-item');
  if (!card) return;
  var choices = card.querySelectorAll('.posy-cover-choice');
  choices.forEach(function (item) { item.setAttribute('aria-pressed', String(item === choice)); });
  var imageLink = card.querySelector('.grid__image__match');
  if (!imageLink) return;
  var preview = imageLink.querySelector('.posy-card-preview-image');
  if (!preview) {
    preview = document.createElement('img');
    preview.className = 'posy-card-preview-image';
    preview.loading = 'lazy';
    imageLink.appendChild(preview);
  }
  preview.src = choice.dataset.coverImage;
  preview.alt = choice.dataset.coverAlt;
  var url = choice.dataset.coverUrl;
  card.querySelectorAll('.grid__image__match, .main_product_title a, .product-grid--price > a, .shop-now-button, .quick-add-button-variants').forEach(function (link) {
    link.href = url;
  });
  imageLink.title = choice.dataset.coverName;
  imageLink.setAttribute('aria-label', 'View 6x9 Weekly Planner - ' + choice.dataset.coverName);
  var coverName = card.querySelector('.main_product_title .product-grid--vendor-text');
  if (coverName) coverName.textContent = ' ' + choice.dataset.coverName;
  var wishlist = card.querySelector('.collection-wishlist');
  if (wishlist) wishlist.hidden = choice.dataset.coverHandle !== card.dataset.posyOriginalHandle;
  var badge = card.querySelector('.jdgm-preview-badge');
  if (badge) badge.hidden = choice.dataset.coverHandle !== card.dataset.posyOriginalHandle;
});

document.addEventListener('click', function (event) {
  var choice = event.target.closest('button.posy-harbor-choice');
  if (!choice) return;
  var card = choice.closest('.grid-view-item');
  if (!card) return;
  var original = choice.dataset.harborOriginal === 'true';
  var draft = choice.dataset.harborDraft === 'true';
  var destination = choice.dataset.harborUrl;
  if (!destination) return;
  card.querySelectorAll('button.posy-harbor-choice').forEach(function (item) {
    item.setAttribute('aria-pressed', String(item === choice));
  });
  var imageLink = card.querySelector('.grid__image__match');
  var preview = imageLink && imageLink.querySelector('.posy-card-preview-image');
  if (imageLink && !preview) {
    preview = document.createElement('img');
    preview.className = 'posy-card-preview-image';
    imageLink.appendChild(preview);
  }
  if (preview) {
    preview.src = choice.dataset.harborImage;
    preview.alt = choice.dataset.harborAlt;
    preview.hidden = original;
  }
  card.querySelectorAll('.grid__image__match, .main_product_title a, .product-grid--price a, .shop-now-button, .quick-add-button-variants').forEach(function (link) {
    link.setAttribute('href', destination);
    if (draft) link.setAttribute('rel', 'nofollow');
    else link.removeAttribute('rel');
  });
  if (imageLink) {
    imageLink.setAttribute('aria-label', 'View Harbor Linen ' + choice.dataset.harborName + ' product page');
    imageLink.title = 'Harbor Linen ' + choice.dataset.harborName;
  }
  var priceLink = card.querySelector('.product-grid--price a');
  if (priceLink) priceLink.hidden = false;
  var previewLabel = card.querySelector('.posy-harbor-preview-label');
  if (previewLabel) previewLabel.hidden = true;
  var wishlist = card.querySelector('.collection-wishlist');
  if (wishlist) wishlist.hidden = !original;
  var quickAdd = card.querySelector('.quick-add-wrapper');
  if (quickAdd && (choice.dataset.harborFamily === 'recipe' || choice.dataset.harborFamily === 'gratitude')) quickAdd.hidden = !original;
  var badge = card.querySelector('.jdgm-preview-badge');
  if (badge) badge.hidden = (choice.dataset.harborFamily === 'monthly' || choice.dataset.harborFamily === 'daily' || choice.dataset.harborFamily === 'recipe' || choice.dataset.harborFamily === 'meal' || choice.dataset.harborFamily === 'notebook' || choice.dataset.harborFamily === 'gratitude' || choice.dataset.harborFamily === 'large-weekly' || choice.dataset.harborFamily === 'large-monthly') && !original;
  var vendor = card.querySelector('.main_product_title .product-grid--vendor-text');
  if (vendor) vendor.textContent = ' Harbor Linen · ' + choice.dataset.harborName;
});

/* Weekly layout inspection is independent from variant selection. */
(function(){
  function formatReviews(){
    document.querySelectorAll('[data-posy-review-count]').forEach(function(el){
      var n=Number(el.dataset.posyReviewCount);
      if(Number.isFinite(n)) el.textContent=n.toLocaleString('en-US');
    });
    document.querySelectorAll('.posy-weekly-product label, .posy-weekly-product button[id="SingleOptionSelector-2"]').forEach(function(el){
      if(el.textContent.trim()==='3. CHOOSE YOUR START MONTH'){
        Array.from(el.childNodes).forEach(function(node){if(node.nodeType===3) node.textContent=node.textContent.replace('3. CHOOSE YOUR START MONTH','3. Choose your start month');});
        el.style.textTransform='none';
      }
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',formatReviews);else formatReviews();
  document.addEventListener('click',function(event){
    var trigger=event.target.closest('[data-posy-enlarge]');
    if(!trigger)return;
    event.preventDefault();
    var dialog=document.querySelector('.posy-layout-dialog');
    if(!dialog){
      dialog=document.createElement('dialog');dialog.className='posy-layout-dialog';
      dialog.innerHTML='<div class="posy-layout-dialog__header"><h2 id="posy-layout-dialog-title"></h2><button type="button" class="posy-layout-dialog__close">Close</button></div><img>';
      dialog.setAttribute('aria-labelledby','posy-layout-dialog-title');document.body.appendChild(dialog);
      dialog.querySelector('button').addEventListener('click',function(){dialog.close();});
      dialog.addEventListener('click',function(e){if(e.target===dialog){var r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
      dialog.addEventListener('close',function(){if(dialog.posyTrigger)dialog.posyTrigger.focus();});
    }
    var label=trigger.dataset.posyImageLabel||'Weekly planner interior';
    dialog.querySelector('h2').textContent=label;
    dialog.querySelector('img').src=trigger.dataset.posyEnlarge;dialog.querySelector('img').alt=label;
    dialog.posyTrigger=trigger;dialog.showModal();
  });
})();
